export const SITI_AGRI = "/sitiagri-rest-api/api_basic/v1";
export const API_CONTEXT = "customerportal-api";
export const API_PREFIX = "api";
export const API_VERSION = "v1";
export const API_PATH = `/${API_CONTEXT}/${API_PREFIX}/${API_VERSION}`;
export const BASE = `/sso2/api/v1`;
